import { createFileRoute } from '@tanstack/react-router';
import { ITServiceDashboardPage } from '@/features/it-service/pages';

export const Route = createFileRoute('/it-service/')({
  component: ITServiceDashboardPage,
});
